import React, { useEffect, useRef } from 'react';
import './ScrollingBanner.css';

const ScrollingBanner = () => {
  const trackRef = useRef(null);
  
  // Liste des statistiques
  const stats = [
    { id: 1, value: '+87%', label: 'de taux de réponse' },
    { id: 2, value: '3.5x', label: 'retour sur investissement' },
    { id: 3, value: '+43%', label: 'de taux de conversion' },
    { id: 4, value: '-35%', label: 'de coût d\'acquisition' }
  ];
  
  // Dupliquer les stats pour créer un effet de boucle infinie
  const duplicatedStats = [...stats, ...stats, ...stats, ...stats];
  
  // Ajuster automatiquement la vitesse d'animation en fonction de la largeur du contenu
  useEffect(() => {
    if (trackRef.current) {
      const trackWidth = trackRef.current.scrollWidth;
      const viewportWidth = window.innerWidth;
      const ratio = trackWidth / viewportWidth;
      
      // Ajuster la durée de l'animation en fonction de la taille
      const duration = Math.max(15, Math.min(30, ratio * 8));
      trackRef.current.style.animationDuration = `${duration}s`;
    }
  }, []);
  
  return (
    <section className="scrolling-banner">
      <div className="banner-container">
        <div className="banner-track" ref={trackRef}>
          {duplicatedStats.map((stat, index) => (
            <div key={`${stat.id}-${index}`} className="banner-item">
              <div className="banner-stat">
                <div className="banner-label">{stat.label}</div>
                <div className="banner-value">{stat.value}</div>
              </div>
            </div>
          ))}
        </div>
      </div>
      <div className="banner-footnote">Sur un panel de 65 entreprises étudiées sur l'année 2024</div>
    </section>
  );
};

export default ScrollingBanner; 